/* eslint-disable react/no-unescaped-entities */

const AboutUsES = () => {
  return (
    <>
      <h1>Sobre Nosotros</h1>
      <h2>Nuestra Misión</h2>
      <div>
        En mind-r.ai, nos hemos embarcado en un viaje para democratizar el
        acceso a la atención de salud mental. Creemos en el poder de la
        tecnología como una herramienta para derribar barreras, borrar límites y
        hacer la terapia universalmente accesible. Hemos visto los efectos
        debilitantes que las condiciones de salud mental no tratadas pueden
        tener en individuos y sociedades - tasas de encarcelamiento en aumento,
        costos económicos que alcanzan hasta el 4% del PIB mundial, y más.
        Nuestra misión es cambiar ese relato.
      </div>
      <div>
        Visualizamos un mundo donde todos, independientemente de su ubicación,
        idioma o situación económica, puedan acceder al apoyo terapéutico que
        necesitan. Queremos normalizar la búsqueda de ayuda, reducir el estigma
        y crear un futuro donde priorizar la salud mental sea la norma, no la
        excepción. Nuestro objetivo no es solo proporcionar un servicio. Es
        iniciar un movimiento hacia una mejor salud mental para todos.
      </div>

      <h2>El Impacto Global de la Salud Mental</h2>
      <div>
        Los problemas de salud mental afectan profundamente a nuestro mundo. Se
        encuentran entre las principales causas de enfermedad y discapacidad en
        todo el mundo, afectando a una de cada cuatro personas en algún momento
        de sus vidas
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        . Los expertos estiman que los problemas de salud mental no tratados
        representan el 13% de la carga total de enfermedad a nivel global
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        .
      </div>
      <div>
        Las implicaciones económicas son sorprendentes. La economía global
        podría perder $16 billones de dólares para 2030 debido a problemas de
        salud mental debido a una disminución de productividad y aumento de los
        costos de atención médica
        <a
          href="https://www.thelancet.com/commissions/global-mental-health"
          target="_blank"
        >
          [2]
        </a>
        . Las personas con problemas de salud mental no tratados a menudo
        enfrentan una calidad de vida reducida, un mayor riesgo de problemas de
        salud física y tasas de desempleo elevadas.
      </div>

      <div>
        Más allá de los factores económicos, los problemas de salud mental
        pueden llevar a niveles más altos de violencia y delincuencia. Hasta el
        90% de los prisioneros han experimentado problemas de salud mental
        <a href="https://www.ncbi.nlm.nih.gov/books/NBK533137/" target="_blank">
          [3]
        </a>
        . Estos problemas también contribuyen a problemas sociales como la falta
        de vivienda y familias desestructuradas.
      </div>

      <div>
        En mind-r.ai, somos muy conscientes de los amplios impactos de los
        problemas de salud mental y estamos comprometidos a ser parte de la
        solución. Al democratizar el acceso a la terapia, buscamos aliviar la
        carga de la salud mental una persona a la vez. Nuestra misión va más
        allá de la atención médica; nos esforzamos por crear un mundo mejor y
        más comprensivo.
      </div>

      <h2>Nuestro Enfoque</h2>
      <div>
        Marcamos nuestro camino para democratizar la terapia con innovación y
        accesibilidad. La inteligencia artificial alimenta nuestra estrategia, y
        la aprovechamos para entender y atender las necesidades y circunstancias
        de cada individuo. Construimos algoritmos complejos para hacer coincidir
        las preferencias del usuario, creando experiencias únicas y
        personalizadas.
      </div>
      <div>
        Sostenemos fuertes creencias en el principio de tecnología impulsada por
        la empatía. Diseñamos cada característica con las necesidades y
        experiencias del usuario para integrar la terapia en la vida cotidiana.
        Nuestro enfoque se centra en la inclusividad, adaptando nuestras
        soluciones para todos, independientemente del idioma, la ubicación, o la
        situación socioeconómica.
      </div>
      <div>
        Con cada paso que damos, nuestra misión de hacer que la atención de
        salud mental sea universalmente accesible nos guía. Nuestro compromiso
        con este objetivo da forma a nuestro enfoque, influye en nuestras
        decisiones y nos impulsa hacia nuestra visión.
      </div>
      <h2>Nuestro Servicio</h2>
      <div>
        En mind-r.ai, hemos transformado el concepto tradicional de terapia
        proporcionando una plataforma basada en voz e impulsada por IA. Conoce a
        Solace, nuestra terapeuta IA, lista para prestar atención en cualquier
        momento y en cualquier lugar. Solace derriba las barreras del tiempo, el
        idioma y la geografía, ofreciendo el tipo de terapia, la duración, el
        tema, el idioma y hasta el acento según las preferencias del usuario.
        Nuestra oferta única abre un mundo de recursos de salud mental a
        cualquier persona, en cualquier momento, en cualquier lugar.
      </div>
      <div>
        Como compañera adaptable, Solace adapta su enfoque a las necesidades de
        cada individuo. Desde proporcionar conversaciones profundas e
        introspectivas hasta ofrecer charlas casuales y reconfortantes, Solace
        se adapta a los estados de ánimo y necesidades de nuestros usuarios. La
        terapia debe ser tan diversa y dinámica como las personas que la buscan.
      </div>
      <div>
        Después de cada sesión de terapia con Solace, generamos un resumen y
        acciones prácticas. Estos no son solo boletines de calificaciones; son
        herramientas para empoderar a los individuos en su continuo viaje de
        salud mental, proporcionando las percepciones y los pasos necesarios
        para seguir progresando. Nos enorgullece estar redefiniendo la terapia,
        haciéndola más accesible, personalizada y efectiva.
      </div>
      <h2>Únete</h2>
      <div>
        ¿Estás listo para dar el primer paso hacia una mejor salud mental? Únete
        a la comunidad de mind-r.ai hoy mismo y descubre un nuevo enfoque en la
        terapia. Conoce a Solace, tu terapeuta de inteligencia artificial, listo
        para escuchar, comprender y acompañarte en tu viaje.
      </div>
    </>
  )
}

export default AboutUsES
